import { useState, useEffect, useRef } from 'react'
import { Button, cn } from 'design-system'

export const HelpButton = () => {
  const [keepOpen, setKeepOpen] = useState<boolean>(true)
  const ref = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    if (window.zE) {
      window.zE('messenger:on', 'close', function () {
        window.zE('messenger', 'hide')
        // timeout hack to bring focus back to the help button
        // after close widget transition finishes
        setTimeout(() => {
          setKeepOpen(true)
          setTimeout(() => {
            if (ref.current) {
              ref.current.focus()
            }
          }, 200)
        }, 300)
      })
    }
  }, [keepOpen, setKeepOpen, ref])

  return (
    <>
      <div className="mt-8" />
      <Button
        aria-label="Open Help and Support"
        ref={ref}
        aria-hidden={!keepOpen ? 'true' : undefined}
        tabIndex={!keepOpen ? -1 : undefined}
        onClick={() => {
          if (window.zE) {
            setKeepOpen(!keepOpen)
            window.zE('messenger', 'show')
            window.zE('messenger', 'open')
          }
        }}
        className={cn({
          'fixed bottom-3 right-3 z-10': true,
          hidden: !keepOpen
        })}>
        <span aria-hidden="true">Help</span>
      </Button>
    </>
  )
}
